export default [
    {
        path: '/user-projects',
        name: 'pageUserProjectsList',
        meta: { title: 'userProjects.listTitle', roles: ['ROLE_ADMIN'] },
        component: () => import('@/pages/user-projects'),
    },
]
